import duckify from '../../tools/duckify';

export const namespace = 'cassie';
export const store = 'shoreSModel';

export const Types = duckify(namespace, store, ['SET_MODEL', 'RESET']);

export const Actions = {
  /**
   * @function setModel
   * @description Stores the result of parsing the uploaded ShorelineS `.mat` file. Kept in
   * Redux (not sessionStorage) because the modeled coastlines GeoJSON can run
   * into several MB — too large/slow for sessionStorage's synchronous,
   * string-only, ~5MB-shared-quota API.
   * @param {object} model
   * @param {string} model.crs
   * @param {boolean} model.hasTemporalData
   * @param {{start: string, end: string}|null} model.dateRange
   * @param {Array<number>|null} model.roiBBox - `[west, south, east, north]`.
   * @param {GeoJSON.FeatureCollection} model.modeledCoastlinesGeoJSON
   * **Called by:
   * @see {ShoreSDataChooser}
   * @memberof module:ShoreS
   * @returns {Object} Redux action of type SET_MODEL.
   */
  setModel: (model) => ({
    type: Types.SET_MODEL,
    payload: model,
  }),

  /**
   * @function reset
   * @description Clears the parsed model (e.g. when leaving the flow or re-uploading).
   * @memberof module:ShoreS
   * @returns {Object} Redux action of type RESET.
   */
  reset: () => ({
    type: Types.RESET,
  }),
};

export default Actions;
